import * as swcHelpers from '@swc/helpers';
import { GET_SUNGLASSES_BY_SLUG } from '../operations/queries/get-sunglasses-by-slug.js';

const getSunglassesBySlug = function() {
    var _ref = swcHelpers.asyncToGenerator(function*({ client , slug , locale  }) {
        const queryResult = yield client.query({
            query: GET_SUNGLASSES_BY_SLUG,
            variables: {
                slug,
                facets: []
            },
            context: {
                headers: {
                    'Accept-Language': locale
                }
            }
        });
        return queryResult;
    });
    return function getSunglassesBySlug(_) {
        return _ref.apply(this, arguments);
    };
}();

export { getSunglassesBySlug };
//# sourceMappingURL=getSunglassesBySlug.js.map
